import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as routerActions from '@ngrx/router-store';
import {Store} from '@ngrx/store';
import {map, mergeMap, tap, withLatestFrom} from 'rxjs/operators';
import {EditModeService} from 'shared/_services/edit-mode.service';
import {EDIT_DRAWING_PATH} from 'shared/magic';
import * as fromEditEntryActions from '../../../projects/journal/src/_actions/edit-entry.actions';
import * as fromLayoutActions from '../../../projects/layout/src/_actions/layout.actions';
import * as fromLayout from '../../../projects/layout/src/_selectors/layout.selectors';
import {LayoutService} from '../../../projects/layout/src/lib/layout.service';

@Injectable({providedIn: 'root'})
export class NavigationEffects {

	closeLayoutComponentsOnRouterNavigationRequest$ = createEffect(() => this.actions$.pipe(
		ofType(routerActions.ROUTER_REQUEST),
		withLatestFrom(this.store.select(fromLayout.selectAllLayoutBarsVisible)),
		mergeMap(([, {bottomBar , floatingSidebar, patientCardVisible}]) => {
			const actions = [];
			if (bottomBar) actions.push(fromLayoutActions.closeBottomBar());
			if (floatingSidebar) actions.push(fromLayoutActions.closeFloatingSidebar());
			if (patientCardVisible) actions.push(fromLayoutActions.closePatientCard());
			return actions;
		})
	));

	closeEditOnNavigation$ = createEffect(() => this.actions$.pipe(
		ofType(routerActions.ROUTER_REQUEST),
		mergeMap(() => {
			if (!this.layoutService.currentEditEntry$.value) return [];
			const navigation = this.router.getCurrentNavigation();
			const targetUrl = navigation?.extractedUrl?.toString() || '';
			const sourceUrl = this.router.url || '';
			const containsDrawingSegment = (url: string) => url.split('?')[0].split('/').includes(EDIT_DRAWING_PATH);
			const isDrawingNavigation = containsDrawingSegment(targetUrl) || containsDrawingSegment(sourceUrl);
			if (isDrawingNavigation) return [];
			return this.editModeService.disable().pipe(
				tap(() => this.layoutService.applyEditEntry(null)),
				map(() => fromEditEntryActions.destroyEdit())
			);
		})
	));

	constructor(
		private actions$: Actions,
		private store: Store,
		private router: Router,
		private editModeService: EditModeService,
		private layoutService: LayoutService
	) {
	}
}
